import { typesense } from '../typesenseClient';
import type { TypesenseDocument } from '../utils';

export const getTypesenseDocumentById = async (
  collection: string,
  idField: string,
  entityId: string,
  apiKey: string,
): Promise<TypesenseDocument | null> => {
  const result = await typesense.multiSearch.perform({
    searches: [
      {
        collection,
        'x-typesense-api-key': apiKey,
        q: '*',
        filter_by: `${idField}:${entityId}`,
        per_page: 1,
      },
    ],
  });
  const searchResult = result.results[0] as {
    hits?: Array<{ document: TypesenseDocument }>;
  };
  if (!searchResult.hits?.length) return null;
  return searchResult.hits[0].document;
};
